<template>
  <v-container>
    <v-row justify="center">
      <v-dialog
        v-model="formDialog"
        max-width="800px"
      >
        <v-card>
          <v-card-title class="px-6 py-4">
            {{ titleProp }}
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-6">
            <v-form ref="form">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="subtitle-2 mb-3">Count Date</div>
                  <v-date-picker
                    v-model="physicalCount.date"
                    full-width
                    no-title
                    color="primary"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <div class="subtitle-2 mb-3">Count Details</div>
                  <v-text-field
                    v-model="physicalCount.name"
                    :rules="[(v) => !!v || 'Name is required', (v) => !!v && v.length <= 45 || 'Max 45 characters']"
                    counter="45"
                    outlined
                    required
                  >
                    <template #label>
                      Name<RedAsterisk />
                    </template>
                  </v-text-field>
                  <inventory-class-select-element
                    v-model="physicalCount.class_ids"
                    :is-add-all="false"
                    :is-required="true"
                    :multiple="true"
                    :is-paint="false"
                    :attach="false"
                    outlined
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions class="px-6 py-4">
            <v-spacer />
            <v-btn
              text
              @click="closeForm"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="submit"
            >
              {{ physicalCount.id ? 'Update' : 'Create' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref="snackbar" />
  </v-container>
</template>

<script>
import PhysicalCountListApi from '@/api/PhysicalCountListApi';
import { mapState } from 'vuex';

export default {
  components: {

  },
  props:
    {
      physicalCountProp: {
        type: Object,
        default: () => {},
      },
      titleProp: {
        type: String,
        default: 'Physical Count',
      },
    },
  data: () => ({
    formDialog: false,
    physicalCount: null,

  }),
  computed: {
    ...mapState({
      invClasses: 'invClasses',
      isDarkMode: 'isDarkMode',
    }),
  },
  watch: {
    physicalCountProp: {
      immediate: true,
      handler(value) {
        if (value) {
          this.physicalCount = value;
          this.physicalCount.class_ids = value.classes.map((x) => x.id);
        } else {
          this.physicalCount = {
            id: 0,
            name: '',
            date: new Date().toISOString().substr(0, 10),
            created_by: this.$store.getters.user.id,
            class_ids: [],
          };
        }
      },
    },
  },

  created() {
    this.initialize();
  },
  methods: {
    initialize() {

    },

    async submit() {
      if (!await this.$refs.form.validate()) return;
      const data = {
        id: this.physicalCount.id,
        name: this.physicalCount.name,
        date: this.physicalCount.date,
        created_by: this.physicalCount.created_by,
        class_ids: this.physicalCount.class_ids,
      };
      let res;
      if (this.physicalCount.id) {
        res = await PhysicalCountListApi.update(data);
      } else {
        res = await PhysicalCountListApi.store(data);
      }
      if (!res) {
        this.$refs.snackbar.showError();
        return;
      }

      if (this.physicalCount.id !== 0) { this.$emit('list-form-success', 'Physical Count Updated'); } else { this.$emit('list-form-success', 'Physical Count Created'); }
      this.closeForm();
    },

    openPhysicalCountForm() {
      this.formDialog = true;
    },
    closeForm() {
      this.reset();
      this.formDialog = false;
    },

    reset() {
      this.physicalCount = {
        id: 0,
        name: '',
        date: new Date().toISOString().substr(0, 10),
        created_by: this.$store.getters.user.id,
        class_ids: [],
      };
    },
  },

};

</script>
